module.exports = __webpack_public_path__ + "static/media/min-globas.7e301037.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/economy/min-globas.svg
// module id = 42
// module chunks = 0